<template>
  <section>
    <div class="stat-grid">
      <div v-for="item in stats" :key="item.label" class="stat-card">
        <div class="stat-label">{{ item.label }}</div>
        <div class="stat-value">{{ item.value }}</div>
      </div>
    </div>
    <div class="panel">
      <h3>近 7 日扫码趋势</h3>
      <div ref="trendChart" class="trend-chart"></div>
    </div>
    <div class="panel rank-panel">
      <h3>产品扫码排行榜 Top10</h3>
      <div v-if="productRank.length" ref="rankChart" class="rank-chart"></div>
      <div v-else class="rank-empty muted">暂无产品扫码数据</div>
    </div>
  </section>
</template>

<script>
import http from '../api'
import * as echarts from 'echarts'

export default {
  data() {
    return {
      overview: {},
      trend: [],
      productRank: [],
      chart: null,
      rankChart: null
    }
  },
  computed: {
    stats() {
      return [
        { label: '总扫码量', value: this.overview.totalScan || 0 },
        { label: '首次正品', value: this.overview.successScan || 0 },
        { label: '重复扫码', value: this.overview.repeatScan || 0 },
        { label: '异常扫码', value: this.overview.abnormalScan || 0 },
        { label: '防伪码总数', value: this.overview.totalCode || 0 },
        { label: '已核验码', value: this.overview.verifiedCode || 0 }
      ]
    }
  },
  mounted() {
    this.load()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    if (this.chart) {
      this.chart.dispose()
    }
    if (this.rankChart) {
      this.rankChart.dispose()
    }
  },
  methods: {
    async load() {
      const [overview, trend, productRank] = await Promise.all([
        http.get('/admin/statistics/overview'),
        http.get('/admin/statistics/trend?days=7'),
        http.get('/admin/statistics/product-rank?limit=10')
      ])
      this.overview = overview
      this.trend = trend
      this.productRank = productRank
      this.$nextTick(() => {
        this.renderChart()
        this.renderRankChart()
      })
    },
    renderChart() {
      if (!this.$refs.trendChart) return
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.trendChart)
      }
      const seriesConfig = [
        { name: '扫码总量', key: 'totalScan', color: '#2563eb' },
        { name: '首次正品', key: 'successScan', color: '#10b981' },
        { name: '重复扫码', key: 'repeatScan', color: '#f59e0b' },
        { name: '异常扫码', key: 'abnormalScan', color: '#ef4444' }
      ]
      this.chart.setOption({
        tooltip: { trigger: 'axis' },
        legend: {
          top: 0,
          right: 0,
          itemWidth: 12,
          itemHeight: 8
        },
        color: seriesConfig.map(item => item.color),
        grid: { left: 42, right: 20, top: 48, bottom: 30 },
        xAxis: { type: 'category', data: this.trend.map(item => item.date), boundaryGap: false },
        yAxis: { type: 'value', minInterval: 1 },
        series: seriesConfig.map(item => ({
          name: item.name,
          type: 'line',
          smooth: true,
          symbolSize: 7,
          lineStyle: { width: 3 },
          data: this.trend.map(trendItem => trendItem[item.key] || 0)
        }))
      })
    },
    renderRankChart() {
      if (!this.$refs.rankChart || !this.productRank.length) return
      if (!this.rankChart) {
        this.rankChart = echarts.init(this.$refs.rankChart)
      }
      this.rankChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        grid: { left: 120, right: 44, top: 18, bottom: 24 },
        xAxis: { type: 'value', minInterval: 1 },
        yAxis: {
          type: 'category',
          inverse: true,
          axisTick: { show: false },
          axisLabel: {
            width: 96,
            overflow: 'truncate'
          },
          data: this.productRank.map(item => item.productName || '未知产品')
        },
        series: [{
          name: '扫码量',
          type: 'bar',
          barMaxWidth: 18,
          itemStyle: {
            color: '#0f766e',
            borderRadius: [0, 4, 4, 0]
          },
          label: {
            show: true,
            position: 'right'
          },
          data: this.productRank.map(item => item.count || 0)
        }]
      })
    },
    resize() {
      if (this.chart) this.chart.resize()
      if (this.rankChart) this.rankChart.resize()
    }
  }
}
</script>

<style scoped>
.trend-chart {
  height: 320px;
}

.rank-panel {
  margin-top: 18px;
}

.rank-chart {
  height: 360px;
}

.rank-empty {
  height: 180px;
  display: grid;
  place-items: center;
  border: 1px dashed #dbe6ef;
  border-radius: 8px;
  background: #f8fafc;
}
</style>
